import { Button, Card, Form, List, Popconfirm } from "antd";
import { useEffect, useState } from "react";
import Router from "../..";
import { useUserStore } from "../../../stores/userStore";

export const CompanyInfo = () => {
  const [form] = Form.useForm();
  const { userInfo, loadUserInfo } = useUserStore();
  const [invitedHistoryList, setInvitedHistoryList] = useState([]);

  const isAgency = userInfo?.user_info?.user_type === "agency";

  const getInvitedHistory = async () => {
    if (userInfo?.type_info?.grade === "master") return;
    const list = await Router.Api.getInvitedHistoryByBrand();
    if (list?.result && Array.isArray(list.result)) {
      setInvitedHistoryList(list.result);
    }
  };

  useEffect(() => {
    if (userInfo?.type_info?.grade !== "master") {
      getInvitedHistory();
    }
  }, [userInfo]);

  const handleDeleteBrand = async () => {
    const res = await Router.Api.deleteBrand();
    if (res) {
      window.location.href = "/workspace/info";
    }
    return res;
  };

  const handleLeaveBrand = async () => {
    const res = await Router.Api.leaveBrand();
    if (res) {
      window.location.href = "/workspace/info";
    }
    return res;
  };

  const handleAcceptInvitation = async (company_id) => {
    const res = await Router.Api.acceptInvitation(company_id);
    if (res) {
      await loadUserInfo();
    }
  };

  // 초대받은 내역 Card
  const renderInvitedHistoryCard = () => (
    <Card
      title="초대받은 내역"
      className={`w-full max-w-[600px] border border-[#d9d9d9] rounded-[10px] bg-white shadow-[0_2px_6px_rgba(0,0,0,0.1)] mb-[30px]`}
    >
      {invitedHistoryList.length > 0 ? (
        <List
          dataSource={invitedHistoryList}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Popconfirm
                  title="초대 수락"
                  description="이 초대를 수락하면 다른 워크스페이스 초대는 모두 거절됩니다."
                  onConfirm={() => handleAcceptInvitation(item.company_id)}
                  okText="수락"
                  cancelText="취소"
                >
                  <Button type="primary" size="small">
                    수락
                  </Button>
                </Popconfirm>,
              ]}
            >
              <div>
                <div>
                  <strong>{`${item.company_name} ${
                    item.user_type === "agency" ? "에이전시" : "브랜드"
                  }`}</strong>
                  에서 당신을 초대하였습니다.
                </div>
                <div className="text-[12px] text-[#999]">{`초대일: ${item.created_at}`}</div>
              </div>
            </List.Item>
          )}
        />
      ) : (
        <div className="p-5 text-center text-[#999]">
          초대받은 내역이 없습니다.
        </div>
      )}
    </Card>
  );

  return (
    <div>
      <h2 className="md:text-4xl text-3xl font-bold">
        {isAgency ? "에이전시" : "브랜드"} 정보
      </h2>
      <div className="flex flex-col lg:flex-row lg:gap-5">
        {/* 왼쪽 컬럼 (데스크탑) / 전체 (모바일/패드) */}
        <div className="w-full max-w-[600px]">
          <Router.BrandForm form={form} />

          {/* -- 모바일/패드에서는 통장 사본이 브랜드 정보 바로 아래 나오게 하기 -- */}
          {userInfo?.type_info?.grade === "master" && (
            <div className="lg:hidden">
              <Router.BankAccntForm />
            </div>
          )}
          <div className="lg:hidden">{renderInvitedHistoryCard()}</div>

          <div>
            {userInfo?.type_info?.grade === "master" ? (
              <Popconfirm
                title={
                  isAgency
                    ? "정말 해당 에이전시를 삭제하시겠습니까?"
                    : "정말 해당 브랜드를 삭제하시겠습니까?"
                }
                description={
                  isAgency
                    ? "이 작업은 되돌릴 수 없으며, 현재 에이전시에 가입된 모든 멤버들, 크리에이터들 및 초대 내역이 삭제됩니다."
                    : "이 작업은 되돌릴 수 없으며, 현재 브랜드에 가입된 모든 멤버들 및 초대 내역이 삭제됩니다."
                }
                onConfirm={handleDeleteBrand}
                okText="삭제"
                cancelText="취소"
                okType="danger"
                okButtonProps={{
                  type: "primary",
                  danger: true,
                  disabled: false,
                }}
                cancelButtonProps={{
                  type: "default",
                  disabled: false,
                }}
              >
                <Button danger disabled={false}>
                  {isAgency ? "에이전시 삭제" : "브랜드 삭제"}
                </Button>
              </Popconfirm>
            ) : (
              userInfo?.type_info?.company_id && (
                <Popconfirm
                  title={
                    isAgency
                      ? "정말 해당 에이전시에서 나가시겠습니까?"
                      : "정말 해당 브랜드에서 나가시겠습니까?"
                  }
                  description="이 작업은 되돌릴 수 없습니다."
                  onConfirm={handleLeaveBrand}
                  okText="나가기"
                  cancelText="취소"
                  okType="danger"
                  okButtonProps={{
                    type: "primary",
                    danger: true,
                    disabled: false,
                  }}
                  cancelButtonProps={{
                    type: "default",
                    disabled: false,
                  }}
                >
                  <Button danger disabled={false}>
                    {isAgency ? "에이전시 탈퇴하기" : "브랜드 탈퇴하기"}
                  </Button>
                </Popconfirm>
              )
            )}
          </div>
        </div>

        {/* 오른쪽 컬럼 (데스크탑만 표시) */}
        <div className="w-full max-w-[600px] hidden lg:flex lg:flex-col">
          {userInfo?.type_info?.grade === "master" && (
            <Router.BankAccntForm cardClassName="lg:mb-[24px]" />
          )}
          {renderInvitedHistoryCard()}
        </div>
      </div>
    </div>
  );
};
